/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AssetsReportsNav4HomeEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const assetsReportsNav4HomeEntryPoint: EntryPoint<
	AssetsReportsNav4HomeEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsReportsNav4HomeEntryPointComponent>(
		/* webpackChunkName: "async-assets-reports-home-entrypoint" */ './AssetsReportsNav4HomePage.tsx',
	),
	getPreloadProps: () => ({}),
});
